import { basename } from './sd-card-entries';
import type { SdCardEntry, SdCardGeneration } from './types';

// prisma VENT session archives on the card: NNNN_YYYY-MM-DD.zip
const SESSION_ZIP_RE = /^\d{4}_\d{4}-\d{2}-\d{2}\.zip$/i;

// A P2.8 recording: <serial>/<yyyymmdd>/<session>/signal_XXX.wmedf
const P28_DAY_SIGNAL_RE = /(?:^|\/)\d{8}\/.+\.(wmedf|emedf|edf)$/i;

// Ordered so each generation's unique marker wins before the more generic ones;
// the card layouts mirror the pTS *FileSystemImporter classes.
export const detectGeneration = (
  entries: SdCardEntry[],
): SdCardGeneration | null => {
  const names = entries.map((entry) => basename(entry.path).toLowerCase());

  // P5 / LUISA: info.json device identity + a *.ldat statistic container.
  if (names.includes('info.json') && names.some((n) => n.endsWith('.ldat'))) {
    return 'p5';
  }

  // P3.2 / prisma VENT: the .sdpvdat marker file or per-session zip archives.
  if (
    names.some((n) => n.endsWith('.sdpvdat')) ||
    names.some((n) => SESSION_ZIP_RE.test(n))
  ) {
    return 'p32';
  }

  // P3 / prismaLINE: the device's own therapy.pdat container sits on the card.
  if (names.includes('therapy.pdat')) {
    return 'p3';
  }

  // P2.8 / prisma SMART/SOFT: config.pscfg + statistic.psstat at the card root,
  // or day-foldered signal recordings.
  if (
    names.includes('config.pscfg') ||
    names.includes('statistic.psstat') ||
    entries.some((entry) => P28_DAY_SIGNAL_RE.test(entry.path))
  ) {
    return 'p28';
  }

  return null;
};
